import React from 'react'
import { FormValues as CompanyFormValues, FieldName } from 'utils/form/companyForm'
import Button from 'components/Button'
import Card from 'components/Card'
import { Checkbox } from 'components/Checkbox'
import { Box } from 'components/Layout'
import { FormikProps } from 'formik'

type FormCompanySettingsProps = {
  onClose: () => void
  onSubmit: (ignoreClearence?: boolean) => void
  companyForm: FormikProps<CompanyFormValues>
  loading: boolean
}

export const FormCompanySettings = ({
  onClose,
  onSubmit,
  companyForm,
  loading,
}: FormCompanySettingsProps) => (
  <Card.Content>
    <Checkbox
      checked={companyForm.values.pcrOnly}
      onChange={() => {
        void companyForm.setFieldValue(FieldName.PCR_ONLY, !companyForm.values[FieldName.PCR_ONLY])
      }}
      label="PCR Only"
    />
    <Checkbox
      checked={companyForm.values.insuranceOnly}
      onChange={() => {
        void companyForm.setFieldValue(
          FieldName.INSURANCE_ONLY,
          !companyForm.values[FieldName.INSURANCE_ONLY]
        )
      }}
      label="Insurance Only"
    />
    <Checkbox
      checked={companyForm.values.automaticallyApproved}
      onChange={() => {
        void companyForm.setFieldValue(
          FieldName.AUTOMATICALLY_APPROVED,
          !companyForm.values[FieldName.AUTOMATICALLY_APPROVED]
        )
      }}
      label="Automatically Approved"
    />
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Button colorVariant="secondary" mr="0.25rem" onClick={onClose}>
        Cancel
      </Button>
      <Button disabled={loading} onClick={() => onSubmit(true)}>
        Save Settings
      </Button>
    </Box>
  </Card.Content>
)
